// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J7eP","controls":"styles_controls__3e3mz","charLimit":"styles_charLimit__3mUJ8","input":"styles_input__33zom","send":"styles_send__o3D-p"};